// extracted by mini-css-extract-plugin
export default {"deviceTypes":"ReasonRejections_deviceTypes__cumWU"};